import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type FormModuleStyleoverrides = {
  wrapper: string
  submitButton: string
  component: string
  successText: string
}

type Props = {
  renderFormModule: (
    styleOverrides: FormModuleStyleoverrides,
  ) => React.ReactNode
  notifyText: string
}

function OnrampMailingListCTA(props: Props) {
  const { renderFormModule, notifyText } = props

  return (
    <div className={style.wrapper}>
      <div className={style.signupContainer}>
        <Paragraph className={style.text}>{notifyText}</Paragraph>
        {renderFormModule({
          wrapper: style.formModule,
          submitButton: style.formModuleSubmitButton,
          component: style.formModuleComponent,
          successText: style.formModuleSuccessText,
        })}
      </div>
    </div>
  )
}

export default OnrampMailingListCTA
